import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IForcePasswordUpdateParams {
  siteUserIds?: string[];
}

export interface IForcePasswordUpdateResult extends IResult {
}

export class ForcePasswordUpdateOnSiteUsersRequest extends Request<IForcePasswordUpdateParams, IForcePasswordUpdateResult> {
  constructor(params: IForcePasswordUpdateParams) {
    super('forcePasswordUpdateOnSiteUsers', params);
  }
}
